import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFirestore } from '@angular/fire/firestore';
import { ApiUrlConstant } from 'src/app/constants/api-url.constant';
import { v4 as uuid } from 'uuid';


@Injectable({
  providedIn: 'root',
})
export class ChatService {
  messages = ApiUrlConstant.messages;
 status = ApiUrlConstant.status;
  constructor(private db: AngularFireDatabase, private dta: AngularFirestore) {}


  
  getUsers() {
    // return this.dta.collection('users').valueChanges()
    // return this.db.object('users').valueChanges();
  }
  getMessagesList() {
    // return this.dta.collection('messages').valueChanges()
    // return this.db.object('messages').valueChanges();
  }

  getParticularUserMessage(user) {
    return this.dta.collection(this.messages).doc(user).valueChanges();

    // return this.dta
    // .collection('messages').doc('3-794').valueChanges();

    // return this.db
    // .list('messages/479-457', ref => {
    // return ref.orderByChild('timeStamp');
    // })
    // .valueChanges();
  }
  sendMessage(messageData, chatId, userMeta) {

    var id = Date.now().toString(36) + Math.random().toString(36).substr(2);
    const newMessage = {};
    newMessage[id] = messageData;
    this.dta
      .collection(this.messages)
      .doc(chatId)
      .set(newMessage, { merge: true });
    // this.db.list(`messages/479-457`).push(messageData);
  }

  sendMessageWithCallBack(messageData, chatId, userMeta) {

    return new Promise((res, rej)=>{
      var id = Date.now().toString(36) + Math.random().toString(36).substr(2);
    const newMessage = {};
    newMessage[id] = messageData;
    this.dta
      .collection(this.messages)
      .doc(chatId)
      .set(newMessage, { merge: true }).then(()=>{
        res(true);
      })
    })

    
    // this.db.list(`messages/479-457`).push(messageData);
  }

  updateMessage(chatId, data) {
    this.dta.collection(this.messages).doc(chatId).set(data)
  }

  setUserStatus(userId, msg) {
    var id = userId?.toString() ?? '';
    this.dta.collection(this.status).doc(id).set(msg);
  }

  getUserStatus(Id) {
    return this.dta.collection(this.status).doc(Id).valueChanges();
  }
  
}
